import React from 'react';
import KnowledgeBaseSection from '../../../sections/AdminDashboard/Support/KnowledgeBase';

const KnowledgeBase = () => {
  return <KnowledgeBaseSection />;
};

export default KnowledgeBase;
